<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('coop_cooper')"
                        :isNewButton="false"
                        :isColumns="true"
                        :isFilter="true"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox
                                :id="'checkbox-' + key"
                                :name="'checkbox-' + key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('coop_cooper')"
                              :isNewButton="false"
                              :isColumns="true"
                              :isFilter="true"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                        <b-form-checkbox
                            :id="'checkbox-' + key"
                            :name="'checkbox-' + key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field != 'buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <!-- Filter -->
            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :export-excel="true"
                              @exportExcel="exportExcel">
                <b-row>
                    <b-col sm="6" md="4" lg="3">
                        <b-form-group :label="$t('coop_company')">
                            <coop-company-selectbox v-model="datatable.queryParams.filter.company_id" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="3">
                        <b-form-group :label="$t('start_date')">
                            <select-date v-model="datatable.queryParams.filter.job_start_date" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="3">
                        <b-form-group :label="$t('end_date')">
                            <select-date v-model="datatable.queryParams.filter.job_end_date" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="3">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox v-model="datatable.queryParams.filter.faculty_code" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="3">
                        <b-form-group :label="$t('department')">
                            <department-selectbox :faculty_code="datatable.queryParams.filter.faculty_code"
                                                  v-model="datatable.queryParams.filter.department_code" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="3">
                        <b-form-group :label="$t('class')">
                            <classes-selectbox v-model="datatable.queryParams.filter.class" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4" lg="3">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input v-model="datatable.queryParams.filter.student_number" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <!-- Datatable -->
            <datatable ref="datatable"
                       :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />

        </app-layout>
    </div>
</template>

<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header';
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox.vue';
    import DepartmentSelectbox from '@/components/interactive-fields/DepartmentSelectbox';
    import ClassesSelectbox from '@/components/interactive-fields/ClassesSelectbox';
    import CoopCompanySelectbox from '@/components/interactive-fields/CoopCompanySelectbox.vue';
    import SelectDate from '@/components/interactive-fields/SelectDate.vue';

    //Service
    import CoopCooperService from "@/services/CoopCooperService";

    //Other
    import qs from 'qs';

    export default {
        name: 'CoopCooperIndex',
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            DatatableFilter,
            Datatable,
            FacultySelectbox,
            DepartmentSelectbox,
            ClassesSelectbox,
            CoopCompanySelectbox,
            SelectDate
        },
        metaInfo() {
            return {
                title: this.$t('coop_cooper')
            };
        },
        data() {
            return {
                datatable: {
                    isLoading: false,
                    filterStatus: true,
                    columns: [
                        {
                            label: this.toUpperCase('student_number'),
                            field: 'student_number',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('name'),
                            field: 'name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('surname'),
                            field: 'surname',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('department'),
                            field: this.getLocaleField('department_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('coop_company'),
                            field: 'company_name',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('position'),
                            field: 'position',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('gno'),
                            field: 'gno',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: this.getLocaleField('status_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('class'),
                            field: 'class',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('telephone'),
                            field: 'mobile_tel',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('email'),
                            field: 'email',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('start_date'),
                            field: 'job_start_date',
                            formatFn: (value) => {
                                return value ? this.toLocaleDate(value) : '';
                            },
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('end_date'),
                            field: 'job_end_date',
                            formatFn: (value) => {
                                return value ? this.toLocaleDate(value) : '';
                            },
                            hidden: false
                        }
                    ],
                    rows: [],
                    total: 0,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: '-id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        watch: {
            'datatable.queryParams.filter.faculty_code': function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.datatable.queryParams.filter.department_code = null;
                }
            }
        },
        created() {
            this.getRows();
        },
        methods: {
            getRows() {
                this.datatable.isLoading = true;
                const config = {
                    params: { ...this.datatable.queryParams },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };

                CoopCooperService.getAll(config)
                    .then((response) => {
                        this.datatable.rows = response.data?.data || response.data || [];
                        this.datatable.total = response.data?.pagination?.total || this.datatable.rows.length;
                        this.datatable.showTable = true;
                    })
                    .catch((error) => {
                        this.showErrors(error, null);
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            },
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.filter();
            },
            exportExcel() {
                const config = {
                    params: { ...this.datatable.queryParams },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };
                CoopCooperService.excelExport(config)
                    .then(response => {
                        this._downloadFile(response, 'Cooper.xlsx');
                    })
                    .catch(error => {
                        this.showErrors(error, null);
                    });
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                if (params && params.length > 0) {
                    this.datatable.queryParams.sort = (params[0].type === 'desc' ? '-' : '') + params[0].field;
                }
                this.getRows();
            }
        }
    };
</script>
